<template>
    <div class="card p-3 mb-4">
        <div class="row g-3">

            <!-- Data UOC -->
            <div class="col-md-3">
                <label class="form-label fw-bold">Data UOC</label>
                <div class="d-flex gap-1">
                    <input type="date" class="form-control" v-model="dateFrom" />
                    <input type="date" class="form-control" v-model="dateTo" />
                </div>
            </div>

            <!-- Oggetto -->
            <div class="col-md-3">
                <label class="form-label fw-bold">Oggetto</label>
                <input type="text" class="form-control" v-model="object" placeholder="Oggetto UOC" />
            </div>

            <!-- Tipo -->
            <div class="col-md-3">
                <label class="form-label fw-bold">Tipo</label>
                <select class="form-select" v-model="tipo">
                    <option value="">Tutti</option>
                    <option value="tematica">Tematica</option>
                    <option value="generica">Generica</option>
                </select>
            </div>

            <!-- Descrizione -->
            <div class="col-md-3">
                <label class="form-label fw-bold">Descrizione</label>
                <input type="text" class="form-control" v-model="notes" placeholder="Descrizione" />
            </div>
        </div>

        <!-- Pulsanti -->
        <div class="row mt-3">
            <div class="col text-end">
                <button class="btn btn-outline-secondary me-2" @click="resetFilters">
                    <i class="bi bi-x"></i> Reset
                </button>
                <button class="btn btn-outline-primary" @click="applyFilters">
                    <i class="bi bi-search"></i> Cerca
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UOCArchiveFilters',
    emits: ['filter'],
    data() {
        return {
            dateFrom: '',
            dateTo: '',
            object: '',
            tipo: '',
            notes: ''
        }
    },
    methods: {
        applyFilters() {
            this.$emit('filter', {
                date_from: this.dateFrom,
                date_to: this.dateTo,
                object: this.object,
                tipo: this.tipo,
                notes: this.notes
            })
        },
        resetFilters() {
            this.dateFrom = ''
            this.dateTo = ''
            this.object = ''
            this.tipo = ''
            this.notes = ''

            this.$nextTick(() => this.applyFilters())
        }
    }
}
</script>
